export interface Hooks {
  on(name: string, callback: () => void): void;
  off(name: string, callback: () => void): void;
  emit(name: string, args: any[]): void;
}

export enum HookType {
  PAGECHANGE = 'pagechange',
  INIT = 'init',
}

export class CustomHooks implements Hooks {
  public static create() {
    return new CustomHooks();
  }

  private hooks: { [eventName: string]: (() => void)[] } = {};

  /* eslint no-useless-constructor:0 */
  /* eslint no-empty-function:0 */
  private constructor() {}
  /* eslint no-empty-function:1 */
  /* eslint no-useless-constructor:1 */

  public on(name: string, callback: () => void): void {
    if (!this.hooks[name]) {
      this.hooks[name] = [callback];
    } else {
      this.hooks[name].push(callback);
    }
  }

  public off(name: string, callback: () => void): void {
    if (!this.hooks[name]?.length) return;
    const idx = this.hooks[name].indexOf(callback);
    this.hooks[name].splice(idx, 1);
  }

  public emit(name: string) {
    if (this.hooks[name]) {
      this.hooks[name].forEach((callback) => callback());
    }
  }
}
